export default [
    {
        "href": "/freeforge/fedriga",
        "src": require("../assets/images/fedriga.png"),
        "titles": {
            "fr": ["Fedriga"],
            "en": [""]
        },
        "manufacturers": []
    },
    {
        "href": "/freeforge/bjorneborg-steel",
        "src": require("../assets/images/bjorneborg.png"),
        "titles": {
            "fr": ["Björneborg Steel"],
            "en": [""]
        },
        "manufacturers": []
    }
]